import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { requestDeleteAccount } from "../Redux/actions";
import { es } from "date-fns/locale";
import { Navigate } from "react-router-dom";
import Swal from "sweetalert2";
import { bindActionCreators } from "redux";

function DeleteAccount(props) {
function deletedata() {
  let data1 = JSON.parse(localStorage.getItem("user"));
  if (data1) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        props.requestDeleteAccount({
          data: {
            token: data1.data.userToken,
            cart_Id: 0
          },
        });
      }
    })
  }
  else {
    Swal.fire({
      title: 'Error!',
      text: 'You are not logged in.',
      icon: 'error',
      confirmButtonText: 'OK'
    });
    Navigate('/login');
  }
}

//delete
useEffect(() => {
  let deleteSaleOrderData = props.data.deleteUserAccount;
  if (deleteSaleOrderData !== undefined) {
    if (deleteSaleOrderData.data) {
      Swal.fire({
        title: 'Good job!',
        text: 'Sale Order deleted successfully..',
        icon: 'success'
      });
    }
  }
  props.data.deleteUserAccount = undefined;
}, [props.data.deleteUserAccount]);

return (
  <div className="delete-account-container">
    <h2>Delete Your Account</h2>
    <p>This action cannot be undone. All your data will be removed.</p>
    <button onClick={() => { deletedata(); }}>Delete My Account</button>
  </div>
)
}

const mapStateToProps = (state) => {
  return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ requestDeleteAccount }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccount);
